export default __webpack_public_path__ + "static/media/EMprint Bold.2e06fe1d.eot";